import { render, staticRenderFns } from "./UserId.vue?vue&type=template&id=477b1820&scoped=true&"
import script from "./UserId.vue?vue&type=script&lang=js&"
export * from "./UserId.vue?vue&type=script&lang=js&"
import style0 from "./UserId.vue?vue&type=style&index=0&id=477b1820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477b1820",
  null
  
)

export default component.exports